// fetch 包装: 自动带 credentials (cookie), 错误抛异常
export const api = {
  async get(path: string) {
    const r = await fetch(path, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  },
  async post(path: string, body?: unknown) {
    const r = await fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  },
  async patch(path: string, body: unknown) {
    const r = await fetch(path, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  },
  async del(path: string, body?: unknown) {
    const r = await fetch(path, {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  },
};

export function formatBytes(n: number): string {
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  if (n < 1024 * 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + ' MB';
  return (n / 1024 / 1024 / 1024).toFixed(2) + ' GB';
}

export function isImage(mime: string) { return mime.startsWith('image/'); }
export function isVideo(mime: string) { return mime.startsWith('video/'); }
export function isAudio(mime: string) { return mime.startsWith('audio/'); }
